import React from 'react'
import { SvgIcon } from '@material-ui/core'

const UserTesting = (props) => {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="25.101" height="22.479" viewBox="0 0 25.101 22.479">
      <g id="Group_5354" data-name="Group 5354" transform="translate(-1375.25 -296.25)" fill="#fff">
        <path id="Path_12426" data-name="Path 12426" className="cls-1" d="M1383.867 306.928a5.339 5.339 0 1 0-5.339-5.339 5.339 5.339 0 0 0 5.339 5.339zm0-9.178a3.839 3.839 0 1 1-3.839 3.839 3.839 3.839 0 0 1 3.839-3.839z" />
        <path id="Path_12427" data-name="Path 12427" className="cls-1" d="m1387.352 309.909-.233-.038a20.684 20.684 0 0 0-6.5 0l-.233.038a6.091 6.091 0 0 0-5.132 6.015 2.805 2.805 0 0 0 2.805 2.8h11.625a2.8 2.8 0 0 0 2.8-2.8 6.091 6.091 0 0 0-5.132-6.015zm2.328 7.32h-11.625a1.3 1.3 0 0 1-1.305-1.3 4.592 4.592 0 0 1 3.868-4.534l.234-.037a19.116 19.116 0 0 1 6.03 0l.234.037a4.592 4.592 0 0 1 3.868 4.534 1.3 1.3 0 0 1-1.304 1.3z" />
        <path id="Path_12428" data-name="Path 12428" className="cls-1" d="M1391.734 305.428a.75.75 0 0 0 0 1.5 5.339 5.339 0 0 0 0-10.678.75.75 0 0 0 0 1.5 3.839 3.839 0 0 1 0 7.678z" />
        <path id="Path_12429" data-name="Path 12429" className="cls-1" d="M1395.22 309.909a3.751 3.751 0 0 0-.589-.047h-1.269a.75.75 0 0 0 0 1.5h1.269a2.179 2.179 0 0 1 .352.028 4.591 4.591 0 0 1 3.868 4.534 1.3 1.3 0 0 1-1.3 1.3h-2.679a.75.75 0 0 0 0 1.5h2.679a2.8 2.8 0 0 0 2.8-2.8 6.091 6.091 0 0 0-5.131-6.015z" />
      </g>
      {' '}

    </SvgIcon>
  )
}

export default UserTesting
